/**
 * URL-hash keys for the dynamic-forms feature's deep-linkable overlays, bound
 * via `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the form id as a hash param (`#edit/5`).
 */
export const DYNAMIC_FORMS_HASH = {
  create: 'create',
  edit: 'edit',
  preview: 'preview',
  delete: 'delete',
  bulkDelete: 'bulk-delete'
} as const;

export type DynamicFormsHashKey =
  (typeof DYNAMIC_FORMS_HASH)[keyof typeof DYNAMIC_FORMS_HASH];
